import React from "react";
import ZakelijkVerbruikInschatterBox from './ZakelijkVerbruikInschatterBox';
import ParticulierVerbruikInschatterBox from "./ParticulierVerbruikInschatterBoxStep2";
import TerugLeveringInschatterBox from "./TerugleveringInschatterBox";
import ParticulierVerbruikInschatterBoxStep1 from './ParticulierVerbuikInschatterStep1';
import ParticulierVerbruikInschatterBoxStep2 from './ParticulierVerbruikInschatterBoxStep2';
import { useState } from "react";

const VerbruikInschatterBox = ({
    dubbeleMeter,
    entiteit,
    teruglevering,
    handleModalClose,
    selectedBuildingType,
    setSelectedBuildingType,
    householdSize,
    sethouseholdSize,
    setReturnedEnergyAmount,
    returnedEnergyAmount,
    setEstimatedReturns,
    estimatedReturns,
    solarPanels,
    setSolarPanels,
    setIsFetchingData,
    setVerbruikEstimaterStep2Output,
    isTerugleveringStep,
    setIsTerugleveringStep,
    step,
    agentID
}) => {



    return (
        <div className="inschatting-content">
            {!isTerugleveringStep && (
                <>

                    {entiteit === 'Zakelijk' && (
                        <ZakelijkVerbruikInschatterBox
                            selectedBuildingType={selectedBuildingType}
                            setSelectedBuildingType={setSelectedBuildingType}
                            setIsFetchingData={setIsFetchingData}
                            setVerbruikEstimaterStep2Output={setVerbruikEstimaterStep2Output}
                            agentID={agentID}
                        />
                    )}
                    {entiteit === 'Particulier' && step == 1 && (

                        <ParticulierVerbruikInschatterBoxStep1
                            householdSize={householdSize}
                            sethouseholdSize={sethouseholdSize}
                        />
                    )}

                    {entiteit === 'Particulier' && step == 2 && (

                        <ParticulierVerbruikInschatterBoxStep2
                            householdSize={householdSize}
                            selectedBuildingType={selectedBuildingType}
                            setSelectedBuildingType={setSelectedBuildingType}
                            setIsFetchingData={setIsFetchingData}
                            setVerbruikEstimaterStep2Output={setVerbruikEstimaterStep2Output}
                            agentID={agentID}
                        />
                    )}

                </>
            )}

            {(teruglevering && isTerugleveringStep) && (
                <TerugLeveringInschatterBox
                    dubbeleMeter={dubbeleMeter}
                    setReturnedEnergyAmount={setReturnedEnergyAmount}
                    returnedEnergyAmount={returnedEnergyAmount}
                    setEstimatedReturns={setEstimatedReturns}
                    estimatedReturns={estimatedReturns}
                    solarPanels={solarPanels}
                    setSolarPanels={setSolarPanels}

                />
            )}


        </div>
    );
};

VerbruikInschatterBox.displayName = 'VerbruikInschatterBox';
export default VerbruikInschatterBox;